export interface UpdateWorkflowSectionDto {
    name: string;
}
